import {
  Component,
  input,
  output,
  computed,
  SimpleChanges,
  signal,
  inject,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FormCachingService, TranslatablePair, User } from '@frontend/common';
import { TranslationService } from '@frontend/common';
import { UserAvatarPipe } from '../../../ui/images';
import { TranslocoModule } from '@jsverse/transloco';

type Poster = {
  fname: string;
  lname: string;
  avatar_disk: string;
  avatar_path: string;
}

@Component({
  selector: 'frontend-comment-form-type-two',
  templateUrl: './comment-form-type-two.component.html',
  styleUrls: ['./comment-form-type-two.component.scss'],
  standalone: true,
  imports: [FormsModule, TranslocoModule, UserAvatarPipe],
})
export class CommentFormTypeTwoComponent implements OnInit {
  user = input<User>();
  poster = computed<Partial<Poster> | null>(() => {
    const user = this.user();
    if (user) {
      return {
        fname: user.fname || '',
        lname: user.lname || '',
        avatar_disk: user.avatar_disk,
        avatar_path: user.avatar_path,
      };
    } else {
      return null;
      // return {
      //   fname: 'Not yet logged in',
      //   lname: 'Guest',
      //   picture: this.defaultAvatar,
      // };
    }
  });
  loading = input<boolean>(false);
  loadingTranslation = signal<boolean>(false);
  disabled = input<boolean>(false);
  clearCommentForm = input<boolean | undefined>(undefined);
  postComment = output<string>();
  formCachingService = inject(FormCachingService);
  formCachingKey = input<string | undefined>(undefined);
  rows = input<number>(3);
  translatablePairs = input<TranslatablePair[]>([]); // Allow the user to translate FR->EN, for example


  message: string | undefined;
  defaultAvatar =
    'https://res.cloudinary.com/cebt/image/upload/v1616972586/users/avatars/default-avatar.gif';
  error = signal<string | { message: string, meta: any } | undefined>(undefined);
  errorString = computed(() => {
    if (this.error()) {
      return typeof this.error() === 'string' ? this.error() : (this.error() as { message: string, meta: any }).message;
    }
  });
  errorObject = computed(() => {
    if (this.error()) {
      return typeof this.error() === 'object' ? this.error() : null;
    }
  });
  translationService = inject(TranslationService);

  onMessageChange() {
    const formCachingKey = this.formCachingKey();
    if (formCachingKey) {
      this.formCachingService.cacheDataItem({ message: this.message }, formCachingKey);
    }
  }

  sendForTranslation(pair: TranslatablePair) {
    this.error.set(undefined);
    const trimmedMessage = (this.message ?? '').trim();
    const sourceLocale: string = this.translationService.getDefaultLocaleFromGenericLanguage(pair.source_lang.iso);
    const targetLocale: string = this.translationService.getDefaultLocaleFromGenericLanguage(pair.target_lang.iso);
    if (!trimmedMessage) {
      return
    }
    this.getTranslation({ message: trimmedMessage }, targetLocale, sourceLocale);
  }
  getTranslation(textsAsObject: { [key: string]: string }, target_lang: string, source_lang: string) {
    const keys = Object.keys(textsAsObject);
    const values = Object.values(textsAsObject);
    this.error.set(undefined);
    this.loadingTranslation.set(true);
    return this.translationService.getTranslation(textsAsObject, target_lang, source_lang).subscribe((translations: { [key: string]: string }) => {
      this.loadingTranslation.set(false);
      this.message = translations['message'];

    }, error => {
      this.loadingTranslation.set(false);
      this.error.set(error);
    }
    );
  }

  doPostComment() {
    const trimmedMessage = (this.message ?? '').trim();
    if (!trimmedMessage) {
      this.message = '';
      return;
    }
    this.postComment.emit(this.message);
  }
  ngOnInit() {

  }
  ngOnChanges(changesObject: SimpleChanges) {
    if (changesObject.clearCommentForm && changesObject.clearCommentForm.currentValue !== undefined) {
      this.message = '';
    }
    if (changesObject.formCachingKey && changesObject.formCachingKey.currentValue !== undefined) {
      const formCachingKey = this.formCachingKey();
      if (formCachingKey && this.formCachingService.getDataItem(formCachingKey)) {
        const cachedData = this.formCachingService.getDataItem(formCachingKey);
        if (cachedData && cachedData['message']) {
          this.message = cachedData['message'];
        }
      }
    }
  }

}
